import { environment } from '../../environments/environment';

export function getSplitConfiguration(userId: string): SplitIO.IBrowserSettings {
    return {
        core: {
            authorizationKey: environment.SPLIT.apiKey,
            key: userId
        },
        startup: {
            readyTimeout: 1.5 // 1.5 sec
        }
    }
}

export const APP_VERSION_KEYS = generateAppVersionKeys();

function generateAppVersionKeys(): {} {
    // add app version attributes
    const appVersionString = environment.APP_VERSION;
    const appVersion = appVersionString.split(".");
    if (appVersion.length >= 2) {
        return {
            'majorAppVersion': appVersion[0],
            'minorAppVersion': appVersion[1]
        };
    }
    return {};
}

export function getSplitAttributes(additionalAttributes: {}, region_id: number) {
    return {
        region_id,
        ...APP_VERSION_KEYS,
        ...additionalAttributes
    }
}
